<template>
  <div class="personal_tax_per_year">
    <div class="column">
      <b-field
        :label="`${$t('salary_income')}`"
        :message="$t(validation.firstError('salaryIncomeValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="salaryIncomeValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('remuneration_income')}`"
        :message="$t(validation.firstError('remunerationIncomeValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="remunerationIncomeValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('manuscript_income')}`"
        :message="$t(validation.firstError('manuscriptIncomeValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="manuscriptIncomeValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('royalties_income')}`"
        :message="$t(validation.firstError('royaltiesIncomeValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="royaltiesIncomeValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('social_insurance')}`"
        :message="$t(validation.firstError('socialInsuranceValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="socialInsuranceValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div class="column">
      <b-field
        :label="`${$t('deductions')}`"
        :message="$t(validation.firstError('deductionsValue'))"
      >
        <p class="control">
          <b-button>¥RMB</b-button>
        </p>
        <b-input
          v-model="deductionsValue"
          :placeholder="`${$t('please_input_int_amt')}`"
        />
      </b-field>
    </div>

    <div v-if="isShowResult" class="column">
      <b-table
        :data="this.tableData"
        :columns="this.tableColumns"
        :hoverable="true"
        :bordered="true"
        :striped="true"
      >
      </b-table>
    </div>

    <div v-if="isShowResult" class="column is-full">
      1.{{ $t("remark_personal_per_year_1") }}
    </div>

    <div v-if="isShowResult" class="column is-full">
      2.{{ $t("remark_personal_1") }}
    </div>

    <div class="column">
      <b-button
        @click="calculate"
        class="is-primary"
        style="background-color: rgba(46,110,182,0.9)"
      >
        {{ $t("calculate") }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      salaryIncomeValue: 0,
      remunerationIncomeValue: 0,
      manuscriptIncomeValue: 0,
      royaltiesIncomeValue: 0,
      socialInsuranceValue: 0,
      deductionsValue: 0,
      tableData: "",
      tableColumns: "",
      isShowResult: false,
    };
  },

  validators: {
    salaryIncomeValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    remunerationIncomeValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    manuscriptIncomeValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    royaltiesIncomeValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    socialInsuranceValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
    deductionsValue: function(value) {
      return this.$validator()
        .value(value)
        .required()
        .greaterThan(-1)
        .integer();
    },
  },

  methods: {
    calculate() {
      this.tableData = [
        {
          total_income_amount: this.$options.filters.formatNumber(
            this.calTotalIncomeAmount()
          ),
          expect_tax_value: this.$options.filters.formatNumber(
            this.calExpectTaxValue()
          ),
          personal_tax: this.$options.filters.formatNumber(
            this.calPersonalTax()
          ),
        },
      ];

      this.columns();

      this.$validate().then((success) => {
        if (success) {
          this.isShowResult = true;
        }
      });
    },

    calTotalIncomeAmount() {
      const result =
        parseInt(this.salaryIncomeValue) +
        parseInt(this.remunerationIncomeValue) * 0.8 +
        parseInt(this.manuscriptIncomeValue) * 0.8 * 0.7 +
        parseInt(this.royaltiesIncomeValue) * 0.8;
      return result;
    },

    calExpectTaxValue() {
      const value =
        this.calTotalIncomeAmount() -
        this.socialInsuranceValue -
        this.deductionsValue;
      const result = value - 60000;
      if (result < 0) {
        return 0;
      } else {
        return result;
      }
    },

    calPersonalTax() {
      let tax_amt_level1 = 0;
      let tax_amt_level2 = 0;
      let tax_amt_level3 = 0;
      let tax_amt_level4 = 0;
      let tax_amt_level5 = 0;
      let tax_amt_level6 = 0;
      let tax_amt_level7 = 0;
      const taxRate = [0.03, 0.1, 0.2, 0.25, 0.3, 0.35, 0.45];
      const value = this.calExpectTaxValue();

      if (value > 960000) {
        tax_amt_level7 = (value - 960000) * taxRate[6];
      }

      if (value > 660000) {
        if (value > 960000) {
          tax_amt_level6 = (960000 - 660000) * taxRate[5];
        } else {
          tax_amt_level6 = (value - 660000) * taxRate[5];
        }
      }

      if (value > 420000) {
        if (value > 660000) {
          tax_amt_level5 = (660000 - 420000) * taxRate[4];
        } else {
          tax_amt_level5 = (value - 420000) * taxRate[4];
        }
      }

      if (value > 300000) {
        if (value > 420000) {
          tax_amt_level4 = (420000 - 300000) * taxRate[3];
        } else {
          tax_amt_level4 = (value - 300000) * taxRate[3];
        }
      }

      if (value > 144000) {
        if (value > 300000) {
          tax_amt_level3 = (300000 - 144000) * taxRate[2];
        } else {
          tax_amt_level3 = (value - 144000) * taxRate[2];
        }
      }

      if (value > 36000) {
        if (value > 144000) {
          tax_amt_level2 = (144000 - 36000) * taxRate[1];
        } else {
          tax_amt_level2 = (value - 36000) * taxRate[1];
        }
      }

      if (value <= 36000) {
        tax_amt_level1 = value * taxRate[0];
      } else {
        tax_amt_level1 = 36000 * taxRate[0];
      }

      return (
        tax_amt_level1 +
        tax_amt_level2 +
        tax_amt_level3 +
        tax_amt_level4 +
        tax_amt_level5 +
        tax_amt_level6 +
        tax_amt_level7
      );
    },

    columns() {
      this.tableColumns = [
        {
          field: "total_income_amount",
          label: this.$t("total_income_amount"),
          numeric: true,
        },
        {
          field: "expect_tax_value",
          label: this.$t("expect_tax_value"),
          numeric: true,
        },
        {
          field: "personal_tax",
          label: this.$t("personal_tax"),
          numeric: true,
        },
      ];
    },
  },
};
</script>
